export default __webpack_public_path__ + "static/media/img4-b.10801658.png";